var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDefaultGrupoDeEstudo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 230,
    viewBox: "0 0 370 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 230,
    rx: 16,
    transform: "translate(0.29)",
    fill: "#f88436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,3A13,13,0,0,0,3,16V214a13,13,0,0,0,13,13H354a13,13,0,0,0,13-13V16A13,13,0,0,0,354,3H16m0-3H354a16,16,0,0,1,16,16V214a16,16,0,0,1-16,16H16A16,16,0,0,1,0,214V16A16,16,0,0,1,16,0Z",
    transform: "translate(0.29)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.088 -32.659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.018,97.044a21.192,21.192,0,0,1-30.043-.015L16.929,79.885a21.49,21.49,0,0,1,0-30.232l5.745-5.779L51.987,73.356,65.568,59.7,36.256,30.214l-7.58-7.623L15.1,36.25,9.35,42.029a32.327,32.327,0,0,0,0,45.479L26.4,104.652a31.878,31.878,0,0,0,45.217,0L98.755,76.021V61.973Z",
    transform: "translate(140 68.557)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039.01,3.629,0,3.59,13.557,0,13.567Z",
    transform: "translate(145.085 90.903) rotate(-45)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039.01,3.629,0,3.59,13.557,0,13.567Z",
    transform: "translate(193.562 147.349) rotate(-45)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039.01,3.629,0,3.59,13.557,0,13.567Z",
    transform: "translate(201.179 140.1) rotate(-45)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039.01,3.629,0,3.59,13.557,0,13.567Z",
    transform: "translate(209.515 131.939) rotate(-45)",
    fill: "#0c1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039.01,3.629,0,3.59,13.557,0,13.567Z",
    transform: "translate(152.603 83.566) rotate(-45)",
    fill: "#0c1151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDefaultGrupoDeEstudo);
export default __webpack_public_path__ + "static/media/img-default-grupo-de-estudo.25e664e1f62b33f415799e71b2e02487.svg";
export { ForwardRef as ReactComponent };